import { Stack, Typography, Box } from "@mui/material";
import { ReactElement } from "react";

interface StepperStep {
    title: string;
    icon: ReactElement;
    subtitle?: string;
    details?: string[];
}

interface StepperProps {
    steps: StepperStep[];
}

const Stepper: React.FC<StepperProps> = ({ steps }) => {
    return (
        <Stack gap={5} direction="row" alignItems="flex-start">
            <Box position="relative" sx={{ minHeight: "90%", top: 12, left: 60, }}>
                {steps.map((_, index) => (
                    <Box
                        key={index}
                        sx={{
                            position: "absolute",
                            top: index === 0 ? 20 : 0,
                            bottom: index === steps.length - 1 ? 20 : 0,
                            left: "50%",
                            width: "2px",
                            bgcolor: "primary.main",
                        }}
                    />
                ))}
            </Box>

            <Stack gap={5}>
                {steps.map((step, index) => (
                    <Stack key={index} direction="row" gap={5} alignItems={"flex-start"}>
                        <Stack direction={"row"} gap={2} alignItems={"center"} sx={{ position: "relative" }}>
                            <Box
                                sx={{
                                    width: 45,
                                    height: 45,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "primary.main",
                                }}
                            >
                                {step.icon}
                            </Box>
                            <Stack gap={1} alignItems={"flex-start"}>
                                <Typography variant="report.card.info.title">{step.title}</Typography>
                                {step.subtitle && <Typography variant="report.info.label">{step.subtitle}</Typography>}
                            </Stack>
                        </Stack>

                        {step.details && (
                            <ul style={{ padding: 0, margin: 0 }}>
                                {step.details.map((detail, detailIndex) => (
                                    <li style={{ padding: 0 }} key={detailIndex}>
                                        <Typography variant="caption">{detail}</Typography>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default Stepper;
